import { useCallback, useEffect, useState } from 'react';
import { notificationsService } from '../../../services/photoEngagementService';
import { NOTIFICATIONS_CHANGED_EVENT } from '../constants';

export function useNotificationsUnread({ enabled = true, pollMs = 15000 } = {}) {
  const [unreadTotal, setUnreadTotal] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await notificationsService.unreadCount();
      setUnreadTotal(Number(data?.unread_count) || 0);
    } catch {
      // badges are best-effort
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setUnreadTotal(0);
      return undefined;
    }
    refresh();
    const onChange = () => {
      refresh();
    };
    window.addEventListener(NOTIFICATIONS_CHANGED_EVENT, onChange);
    const intervalId = setInterval(refresh, pollMs);
    return () => {
      window.removeEventListener(NOTIFICATIONS_CHANGED_EVENT, onChange);
      clearInterval(intervalId);
    };
  }, [enabled, pollMs, refresh]);

  return { unreadTotal, refresh };
}

export function notifyNotificationsChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED_EVENT));
  }
}
